module.exports = __webpack_public_path__ + "static/img/tcqn7.ab7be0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/tcqn7.png
// module id = 386
// module chunks = 0